import type { Entity } from '@/modules/Project/types'
import type { Project } from '@/modules/Projects/useProjects'
import { getHubFileFields } from '@/modules/Workspaces/KnowledgeHub/Hubs/getHubFileFields'
import type { HubFile } from '@/modules/Workspaces/KnowledgeHub/Hubs/types'

export function parseHubEntities(props: { fileProject: Project; entities: Entity[] }): HubFile[] {
  const { fileProject, entities } = props

  return entities.map((entity) => {
    const fields = getHubFileFields({ properties: fileProject.properties, entity })
    const fileName = fields.path.manualValue?.split('/').pop() || ''

    return { fileProject, entity, fields, fileName }
  })
}
